import { isNumber } from 'util';
var POINTS = 'pt';
// This is mapping table from browser size (1-7) to PT
export var FONTSIZE_MAPPING = [
    8 /*1*/,
    10 /*2*/,
    12 /*3*/,
    14 /*4*/,
    18 /*5*/,
    24 /*6*/,
    36 /*7*/,
];
export var FONT_SIZES = [8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72];
// This list is used to populate font size picker drop down
export var FONT_SIZE_LIST = FONT_SIZES.map(function (size) { return size.toString(); });
export function getFontSizeFromSizeOrIndex(sizeOrIndex) {
    return isNumber(sizeOrIndex) && sizeOrIndex <= 7
        ? FONTSIZE_MAPPING[sizeOrIndex - 1]
        : sizeOrIndex;
}
export function getFontSizeInPoints(size) {
    var result = getFontSizeFromSizeOrIndex(size).toString();
    return result ? result + POINTS : result;
}
//# sourceMappingURL=FontSize.js.map